<template>
  <div class="video-card">
    <div
      class="video-card-image"
      @click="gotoVideo"
    >
      <a
        class="play-icon"
        href="#"
      >
        <i class="fas fa-play-circle" />
      </a>
      <a href="#">
        <img
          v-if="options.videos.show.placeholders"
          src="http://placehold.it/600x300"
        >
        <img
          v-else
          :id="`img-${data.pid}`"
          :src="data.thumbnail"
          class="img-fluid"
          alt=""
        >
      </a>
      <div
        v-if="options.videos.show.duration"
        class="time"
      >
        {{ data.duration_str }}
      </div>
    </div>
    <div
      v-if="options.videos.show.title || options.videos.show.tags || options.videos.show.views || options.videos.show.date || options.videos.show.timeAgo"
      class="video-card-body"
    >
      <div
        v-if="options.videos.show.title"
        class="video-title"
      >
        <a @click="gotoVideo">
          {{ data.title }}
        </a>
      </div>
      <div
        v-if="options.videos.show.tags"
        class="video-page text-success tags"
      >
        <b-badge
          v-for="tag in data.tags"
          :key="tag.slug"
          variant="success"
          @click="selectTag(tag)"
        >
          {{ tag.name }}
        </b-badge>
        <b-badge
          class="channel"
          variant="success"
          @click="clickChannel()"
        >
          {{ data.channel_title }}
        </b-badge>
      </div>
      <div
        v-if="options.videos.show.views || options.videos.show.date || options.videos.show.timeAgo"
        class="video-view"
      >
        <template v-if="options.videos.show.views">
          <i class="fas fa-eye" /> {{ data.view_count }} {{ $t('JSON.views') }}
        </template>
        <template v-if="options.videos.show.date">
          &nbsp;<i class="fas fa-calendar-alt" /> {{ data.published_at }}
        </template>
        <template v-if="options.videos.show.timeAgo">
          (
          <Timeago
            locale="en"
            :datetime="data.published_at"
            :converter-options="{ includeSeconds: false, addSuffix: true }"
          />)
        </template>
      </div>
    </div>
    <div
      v-if="options.videos.show.optionsDropdown"
      class="options"
    >
      <VideoOptionsDropdown :video="data" />
    </div>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
  components: {
    VideoOptionsDropdown: () => import('@/components/video/VideoOptionsDropdown'),
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: () => 0,
    },
  },

  computed: {
    ...sync([
      'site.options', //
    ]),
  },

  mounted() {
    // console.log(this.data);

    $(`#img-${this.data.pid}`).on('load', () => {
      if ($(`#img-${this.data.pid}`)[0].naturalWidth !== 480) {
        console.log(`error loading ${this.data.pid}`);
        this.$http.post(`/api/fetcher/posts/${this.data.pid}/verify`);
      }
    });
  },

  methods: {
    gotoVideo() {
      this.$router.push({
        name: 'video',
        params: { pid: this.data.pid },
      });
    },

    inspect() {
      Bus.$emit('inspect_post', this.data.pid);
    },

    selectTag(tag) {
      // console.log('tag clicked', tag);
      Bus.$emit('tags_selected', [tag]);
      this.$router.push({
        name: 'home',
      });
    },

    clickChannel() {
      // console.log('channel clicked', this.data.cid);
      // const url = `https://www.youtube.com/channel/${this.data.cid}/videos`;
      const url = `https://www.youtube.com/channel/${this.data.cid}/videos?query=highlights`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
.tags .badge {
  cursor: pointer;
  margin-right: 2px;
  margin-bottom: 3px;
  padding-bottom: 4px;
  text-transform: capitalize;
  font-size: 1em;
}

.tags .badge.channel {
  background: linear-gradient(135deg, #ff516b 0%, #826cfd 100%);
}

.video-card {
  position: relative;
}

.options {
  position: absolute;
  top: -14px;
  right: -2px;
}
</style>
